<script setup lang="ts">
import MonthYearPicker from "@/components/ui/input/MonthYearPicker.vue";
import {computed, defineModel} from "vue";
import type {Region} from "@/types/files";
import RegionSelector from "@/components/ui/input/RegionSelector.vue";
import type {DistrictKey} from "@/composables/functions/getDistrictName";
import type {RegionKey} from "@/composables/functions/getRegionName";

interface Props {
  selectedRegions?: Region[];
  paramsSearchQuery?: string;
  activeMonth?: string;
  activeYear?: number;
}

const props = withDefaults(defineProps<Props>(), {
  size: "medium",
  selectedRegions: () => [],
  paramsSearchQuery: "",
  activeMonth: "january",
  activeYear: () => new Date().getFullYear()
});

const emit = defineEmits<{
  "update:selectedRegions": [value: Region[]];
  "update:paramsSearchQuery": [value: string];
  "update:activeMonth": [value: string];
  "update:activeYear": [value: number];
}>();

const selectedDistrict = defineModel<DistrictKey | null>("selectedDistrict", {required: true});
const selectedRegion = defineModel<RegionKey | null>("selectedRegion", {required: true});

// Значение строки поиска параметров
const paramsSearchQueryValue = computed({
  get: () => props.paramsSearchQuery,
  set: (value) => emit("update:paramsSearchQuery", value)
});
</script>

<template>
  <div class="toolbar">
    <!-- Выбор региона -->
    <RegionSelector
      v-model:selected-district="selectedDistrict"
      v-model:selected-region="selectedRegion"
    />

    <!-- Выбор месяца и года -->
    <MonthYearPicker
      :model-month="props.activeMonth"
      :model-year="props.activeYear"
      @update:model-month="(value: string) => emit('update:activeMonth', value)"
      @update:model-year="(value: number) => emit('update:activeYear', value)"
    />

    <!--  Поле поиска  -->
    <InputSearchPrimary
      v-model="paramsSearchQueryValue"
      placeholder="Поиск по параметру"
    />
  </div>
</template>

<style scoped lang="scss">
.toolbar {
  display: flex;
  gap: 10px;
}
</style>
